module.exports = __webpack_public_path__ + "static/img/qiye2.51127b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/qiye2.jpg
// module id = dJBr
// module chunks = 52